import { withInstall } from '@bigin/utils'

import ColorPicker from './src/color-picker.vue'

export const BColorPicker = withInstall(ColorPicker)
export default BColorPicker

export * from './src/color-picker'
